angular.module("digitalLeasing.module").component("bankResolution", {
  templateUrl: "ng/components/digitalLeasing/deliberaBanca/bankResolution/bankResolution.view.html",
  bindings: {
    model: "="
  },
  controllerAs: "bankResolutionCtrl",
  controller: function BankResolution() {
    var self = this;

    self.$onInit = function () {
      console.log("model bankResolution", self.model)
    }
  }
});